import type { BetaWelcomeContent } from '../types/beta-welcome';
import '../styles/system-status.css';

interface BetaWelcomeContentViewProps {
  content: BetaWelcomeContent;
  knownIssues?: string[];
  onClose?: () => void;
  onOpenFeedback?: () => void;
  previewMode?: boolean;
}

export default function BetaWelcomeContentView({
  content,
  knownIssues = [],
  onClose,
  onOpenFeedback,
  previewMode = false,
}: BetaWelcomeContentViewProps) {
  return (
    <>
      <div className="beta-feedback-header">
        <h2 id="beta-welcome-title">{content.title}</h2>
        {onClose && (
          <button
            type="button"
            className="beta-feedback-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            ×
          </button>
        )}
      </div>

      <p className="beta-welcome-lead">{content.lead}</p>

      <section className="beta-welcome-section">
        <h3>Ce qui est prêt</h3>
        <ul>
          {content.readyItems.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="beta-welcome-section">
        <h3>Encore instable / en cours</h3>
        <ul>
          {content.unstableItems.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      {knownIssues.length > 0 && (
        <section className="beta-welcome-section beta-welcome-known">
          <h3>Problèmes connus</h3>
          <ul>
            {knownIssues.map(issue => (
              <li key={issue}>{issue}</li>
            ))}
          </ul>
        </section>
      )}

      <section className="beta-welcome-section">
        <h3>{content.feedbackTitle}</h3>
        <p>{content.feedbackText}</p>
      </section>

      {!previewMode && onClose && (
        <div className="beta-feedback-actions">
          <button type="button" className="system-status-btn" onClick={onClose}>
            Commencer
          </button>
          {onOpenFeedback && (
            <button
              type="button"
              className="system-status-btn system-status-btn--primary"
              onClick={onOpenFeedback}
            >
              Signaler un problème
            </button>
          )}
        </div>
      )}
    </>
  );
}
